export default "__VITE_ASSET__CwD05R6D__"